// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"caret-down-small","fill":"props.strokeColor1","d":"M12.0001 15L17.5 9.5H6.5L12.0001 15Z"}}]};

const CaretDownSmallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-down-small',
    ref,
    icon: element,
  },
));

CaretDownSmallIcon.displayName = 'CaretDownSmallIcon';

export default CaretDownSmallIcon;
